export const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M21.811,2.1a1,1,0,0,0-.8-1.6H2.99a1,1,0,0,0-.8,1.6L10,12.592V22.5a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V12.592Z"
        fill="#00e6ca"
      />
      <path d="M12,.5H2.99a1,1,0,0,0-.8,1.6L10,12.592V22.5a1,1,0,0,0,1,1h1Z" fill="#c4f0eb" />
      <path
        d="M21.811,2.1a1,1,0,0,0-.8-1.6H2.99a1,1,0,0,0-.8,1.6L10,12.592V22.5a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V12.592Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
